import { render, staticRenderFns } from "./completions-item.vue?vue&type=template&id=2e755aeb&"
import script from "./completions-item.vue?vue&type=script&lang=js&"
export * from "./completions-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports